const tabOne = document.querySelector('.tab-one');
const tabTwo = document.querySelector('.tab-two');
const tabOneCarousel = document.querySelector('.tab-one-carousel');
const tabTwoCarousel = document.querySelector('.tab-two-carousel');
const explainerVideos = document.querySelectorAll('.carousel video')

const tabOneFlickityCarousel = new Flickity( tabOneCarousel, {
    "cellAlign": "left",
    "contain": true,
    "wrapAround": true,
    "pageDots": false,
});

const tabTwoFlickityCarousel = new Flickity( tabTwoCarousel, {
    "cellAlign": "left",
    "contain": true,
    "wrapAround": true,
    "pageDots": false,
});

const switchCarousel = (e) => {

    e.target.classList.add('active')

    if (e.target.classList.contains('tab-one')) {
        tabOneCarousel.classList.remove('hidden');
        tabTwoCarousel.classList.add('hidden');
        tabOneFlickityCarousel.resize();
        tabTwo.classList.remove('active');
    }

    if (e.target.classList.contains('tab-two')) {
        tabTwoCarousel.classList.remove('hidden');
        tabOneCarousel.classList.add('hidden');
        tabTwoFlickityCarousel.resize()
        tabOne.classList.remove('active');
    }
}

tabOne.addEventListener('click', (e) => {
    switchCarousel(e)
})

tabTwo.addEventListener('click', (e) => {
    switchCarousel(e)
})

explainerVideos.forEach(video => {
    video.addEventListener('mouseenter', () => {
        video.setAttribute('controls', '')
    })
})

explainerVideos.forEach(video => {
    video.addEventListener('mouseleave', () => {
        video.removeAttribute('controls')
    })
})